import React from 'react';

import Column from '@amzn/meridian/column';
import { useAppSelector } from 'src/store/store';

import MultipleSiteDropdown from '../multipleSiteDropdown/multipleSiteDropdown';
import SelectedSiteList from '../selectedSiteList/selectedSiteList';

import './multipleSiteSelection.scss';

const MultipleSiteSelection = () => {
  const { areMultipleSitesSelected } = useAppSelector((state) => state.defaultSettingsPage);

  return (
    <Column className="default-settings__content__multiple-selection">
      {areMultipleSitesSelected && (
        <>
          <MultipleSiteDropdown />
          <SelectedSiteList />
        </>
      )}
    </Column>
  );
};

export default MultipleSiteSelection;
